<div class="cs-div text-left">
  <h1 class="cs-title m-0">{{day}} <small class="gold">{day, plural, =0 {day} =1 {day} other {days}}</small></h1>
  <p class="m-0">to launch</p>
  <h3 class="cs-timeout m-0">
    <div class="cs-digit">{{hour}} <small>{hour, plural, =00 {hr} =01 {hr} other {hrs}}</small></div>&nbsp;&nbsp;:&nbsp;&nbsp;<div class="cs-digit">{{minute}} <small>{minute, plural, =00 {min} =01 {min} other {mins}}</small></div>&nbsp;&nbsp;:&nbsp;&nbsp;<div class="cs-digit">{{second}} <small>{second, plural, =00 {sec} =01 {sec} other {secs}}</small></div>
  </h3>
</div>